export enum Masks {
    TIME = "00:m0:s0",
    GROUP_HOUR = "Hh:m0"
}
